import { assign } from 'lodash';
import keyMirror from 'keymirror';
import EventEmitter from '@wsb/commerce-event-emitter';
import { AppDispatcher } from '@wsb/guac-widget-shared/lib/common/ols-core/shared-bundle';

export const DigitalWalletConstants = keyMirror({
  SESSION_STARTED: null,
  SESSION_CANCELED: null,
  SESSION_FAILED: null,
  AVAILABILITY_WAS_CHECKED: null,
  PAYMENT_REQUEST_IS_AVAILABLE: null,
  POYNT_PAYMENT_REQUEST_IS_AVAILABLE: null,
  POYNT_WAS_LOADED: null,
  STRIPE_WAS_LOADED: null,
  NO_SHIPPING_METHODS: null
});

export const APPLE_PAY = 'apple_pay';
export const GOOGLE_PAY = 'google_pay';

class DigitalWalletStore extends EventEmitter {
  constructor() {
    super(...arguments);

    this.state = {
      timeout: 1000,
      inSession: false,
      stripeWasLoaded: false,
      poyntWasLoaded: false,
      availabilityWasChecked: false,
      applePayIsAvailable: false,
      googlePayIsAvailable: false,
      applePayIsSupported: false
    };
    this.register();
  }

  setState(newState) {
    assign(this.state, newState);
    this.emit('change');
  }

  getState() {
    return this.state;
  }

  register() {
    this.dispatchToken = AppDispatcher.register(({ action: { data, type } }) => {
      switch (type) {
        case DigitalWalletConstants.SESSION_STARTED:
          this.setState({
            inSession: true
          });
          break;
        case DigitalWalletConstants.SESSION_CANCELED:
        case DigitalWalletConstants.SESSION_FAILED:
          this.setState({
            inSession: false
          });
          break;
        case DigitalWalletConstants.STRIPE_WAS_LOADED:
          this.setState({
            stripeWasLoaded: true
          });
          break;
        case DigitalWalletConstants.POYNT_WAS_LOADED:
          this.setState({
            poyntWasLoaded: true
          });
          break;
        case DigitalWalletConstants.AVAILABILITY_WAS_CHECKED:
          this.setState({
            availabilityWasChecked: true
          });
          break;
        case DigitalWalletConstants.POYNT_PAYMENT_REQUEST_IS_AVAILABLE:
          this.setState({
            applePayIsAvailable: data.applePay,
            googlePayIsAvailable: data.googlePay
          });
          break;
        case DigitalWalletConstants.APPLE_PAY_IS_AVAILABLE:
          this.setState({
            applePayIsAvailable: true
          });
          break;
        case DigitalWalletConstants.PAYMENT_REQUEST_IS_AVAILABLE:
          this.setState({
            applePayIsAvailable: true,
            applePayIsSupported: data.applePay
          });
          break;
        case DigitalWalletConstants.NO_SHIPPING_METHODS:
          this.setState({
            poyntWasLoaded: true,
            availabilityWasChecked: true,
            applePayIsAvailable: false,
            googlePayIsAvailable: false
          });
          break;
        default:
          break;
      }
    });
  }
}

export default new DigitalWalletStore();
